import React, { Component, PropTypes } from 'react';
import { Router, Route, IndexRoute , browserHistory, Redirect } from 'react-router';
import { Provider } from 'react-redux';
import { IntlProvider } from 'react-intl';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as UIActions from 'storeState/ui/actions';
import URLService from 'service/URLService';
import { getHistory } from 'service/HistoryService';

import locales from 'src/initLocales';
import {getCurrentLocale} from 'service/LocaleService';
import messages from 'messages';
import _ from 'lodash';
import auth from 'storeState/auth';

import Landing from 'components/screens/landing/Landing';
import Dashboard from 'components/screens/dashboard/Dashboard';
import Tenants from 'components/screens/tenants/Tenants';
import Projects from 'components/screens/projects/Projects';
import Translations from 'components/screens/translations/Translations';
import Users from 'components/screens/users/Users';

import {isTouchDevice} from 'service/MobileService';
import { default as TouchBackend } from 'react-dnd-touch-backend';
import HTML5Backend from 'react-dnd-html5-backend';
import { DragDropContextProvider } from 'react-dnd';

import moment from 'moment';
//import { DragDropContext } from 'react-dnd';


class LocaleRoute extends Component {
    render = () => {
        const {path, ...otherProps} = this.props;
        return <Route
            path = {`/:lang/${_.trimStart(this.props.path,"/")}`}
            {...otherProps}
        />
    }
}

class App extends Component {

    getIntlProviderData = () => {
      const locale = getCurrentLocale();
      moment.locale(locale);
      const intlData = {
        locale: locale,
        messages: messages[locale],
      };
      return intlData;
    }

    /* If the token is already present then directly go to Landing  */
    conditionalRedirect = (condition, redirectPath, elseChild) =>{
        return (
            <Choose>
                <When condition={condition}>
                    <Redirect to={{
                        pathname: `/${getCurrentLocale()}${redirectPath}`,
                    }} />
                </When>
                <Otherwise>
                    {elseChild}
                </Otherwise>
            </Choose>
        )
    }

    render() {

        const isLoggedIn = this.props.isLoggedIn;

        return (
            <DragDropContextProvider backend={isTouchDevice() ? TouchBackend : HTML5Backend}>
                <Provider store={this.props.store}>
                    <IntlProvider {...this.getIntlProviderData()}>
                        <Router key={Math.random()} history={getHistory()} onUpdate={() => window.scrollTo(0, 0)}>
                            <div className="router-wrapper">
                                <Route path="/" exact={true} render={() => {
                                    return (
                                        <Redirect to={{
                                            pathname: `/${getCurrentLocale()}`,
                                        }} />
                                    );
                                }} />

                                <LocaleRoute
                                    path="/"
                                    exact={true}
                                    render={() => this.conditionalRedirect(isLoggedIn, "/dashboard", <Landing view="login" />)}
                                />
                                <LocaleRoute
                                    path="/auth/registration"
                                    render={() => this.conditionalRedirect(isLoggedIn, "/dashboard", <Landing view="registration" />)}
                                />
                                <LocaleRoute
                                    path="/auth/confirm_forgot_password"
                                    render={() => this.conditionalRedirect(isLoggedIn, "/dashboard", <Landing view="confirm_forgot_password" />)}
                                />
                                <LocaleRoute
                                    path="/auth/confirm_email"
                                    render={() => this.conditionalRedirect(isLoggedIn, "/dashboard", <Landing view="confirm_email" />)}
                                />
                                <LocaleRoute
                                    path="/dashboard"
                                    render={() => this.conditionalRedirect(!isLoggedIn, "/", <Dashboard/>)}
                                />
                                <LocaleRoute
                                    path="/translations/:project_id/:project_locale_string_id"
                                    exact={true}
                                    render={(props) => this.conditionalRedirect(!isLoggedIn, "/", <Translations {...props}/>)}
                                />
                                <LocaleRoute
                                    path="/translations/:project_id"
                                    exact={true}
                                    render={(props) => this.conditionalRedirect(!isLoggedIn, "/", <Translations {...props}/>)}
                                />
                                <LocaleRoute
                                    path="/tenants"
                                    render={() => this.conditionalRedirect(!isLoggedIn, "/", <Tenants/>)}
                                />
                                <LocaleRoute
                                    path="/projects"
                                    render={() => this.conditionalRedirect(!isLoggedIn, "/", <Projects/>)}
                                />
                                <LocaleRoute
                                    path="/users"
                                    render={() => this.conditionalRedirect(!isLoggedIn, "/", <Users/>)}
                                />
                            </div>
                        </Router>
                    </IntlProvider>
                </Provider>
            </DragDropContextProvider>
        );
    }
}


function mapStateToProps(state, props) {
    return {
        isLoggedIn: auth.selectors.isLoggedIn(state)
    }
}

function mapDispatchToProps(dispatch) {
    return {
        uiActions: bindActionCreators(UIActions, dispatch),
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(App)



// WEBPACK FOOTER //
// ./src/App.js